import { defineMessages } from 'react-intl';

export default defineMessages({
	cta: {
		id: 'homepage.blogFeed.cta',
		defaultMessage: 'See all blogs',
		description: "Button that takes user to Calm's blog",
	},
});
